<template>
  <div id="xs-web">
    <xs-header />
    <router-view/>
    <xs-footer v-if="this.$route.name === 'index'"></xs-footer>
    <xs-footers v-else></xs-footers>
    <xs-top v-if="this.$route.name !== 'index'"></xs-top>
  </div>
</template>

<script>
import XsHeader from './components/XSHeader'
import XsFooter from './components/XsFooter'
import XsFooters from './components/XsFooters'
import XsTop from './components/XSTop'
export default {
  name: 'App',
  components: {
    XsHeader,
    XsFooter,
    XsFooters,
    XsTop
  }
}
</script>

<style lang="scss">
#xs-web {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #494949;
}
.page {
  position: relative;
  box-sizing: border-box;
  height: 100%;
  padding-top: 70px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue